








































import { InvitableProject } from '@/areas/invitations/invitation-models';
import OtButton from '@/components/global/ot-button.vue';
import OtMultiSelectAutocomplete, {
  IKeyedAutocompleteItem,
} from '@/components/global/ot-multi-select-autocomplete.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    OtMultiSelectAutocomplete,
    OtButton,
  },
})
export default class OtMultiSelectAutocompleteWrapper extends Vue {
  // * PROPS

  // * DATA
  private items: IKeyedAutocompleteItem<string>[] = [
    {
      label: 'Field Text 1',
      data: 'Field Data 1',
      key: 'one',
    },
    {
      label: 'Field Text 2',
      data: 'Field Data 2',
      key: 'two',
    },
    {
      label: 'Field Text 3',
      data: 'Field Data 3',
      key: 'three',
    },
    {
      label: 'Field Text 4',
      data: 'Field Data 4',
      key: 'four',
    },
    {
      label: 'Field Text 5',
      data: 'Field Data 5',
      key: 'five',
    },
    {
      label: 'Field Text 6',
      data: 'Field Data 6',
      key: 'six',
    },
  ];

  private objectItems: IKeyedAutocompleteItem<InvitableProject>[] = [
    {
      data: new InvitableProject({
        code: 'one',
        gid: '1',
        name: 'project one',
        userStatus: null,
      }),
      label: 'project one for the money, two for the show',
      disabled: false,
      key: 'one',
    },
    {
      data: new InvitableProject({
        code: 'two',
        gid: '2',
        name: 'project two',
        userStatus: null,
      }),
      label: 'project two',
      disabled: false,
      key: 'two',
    },
    {
      data: new InvitableProject({
        code: 'three',
        gid: '2',
        name: 'project three',
        userStatus: null,
      }),
      label:
        'project three Those options are already baked in with this model shoot me an email clear blue water but we need distributors to evangelize the new line to local markets, but fire up your browser. Strategic high-level 30,000 ft view. Drill down re-inventing the wheel at the end of the day but curate imagineer, or to be inspired is to become creative.',
      disabled: false,
      key: 'three',
    },
  ];

  private valuePrivate: unknown | null = null;
  private get value() {
    return this.valuePrivate;
  }
  private set value(val: unknown | null) {
    console.log('ot-multi-select-autocomplete-wrapper -> set value', val);
    this.valuePrivate = val;
  }

  private objectValuePrivate: unknown | null = null;
  private get objectValue() {
    return this.objectValuePrivate;
  }
  private set objectValue(val: unknown | null) {
    console.log('ot-multi-select-autocomplete-wrapper -> set objectValue', val);
    this.objectValuePrivate = val;
  }

  // * COMPUTED

  // * WATCHERS

  // * METHODS

  // * LIFECYCLE
}
